import { IconQuote } from '@xing-com/icons';

import * as Styled from '../styles';
import { type ToolProps } from '../types';

export const XingQuoteTool: React.FC<ToolProps> = ({ editor, disabled }) => {
  return (
    <Styled.ToolBarButton
      onClick={() => editor.commands.toggleXingQuote()}
      disabled={disabled}
      className={editor.isActive('xingQuote') ? 'is-active' : ''}
    >
      <IconQuote width={24} height={24} />
    </Styled.ToolBarButton>
  );
};
